import React, {Component} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeaderSample from "../common/headerSample";
import Button from 'react-bootstrap/Button';
import {_axios} from '../../plugins/axios';
import {WebcamCapture} from "../common/camera";
import { URL,USER,ABHIErId, merCompulsoryPackage } from "../../constants/constant";
import BarCodeModal from "../Order/barcode";
import ToasterComponent from "../common/toaster";
import { geolocated } from "react-geolocated";
import watermark, {text} from "watermarkjs";
import UpdateCustomer from "../common/updateCustomer";
import { Form, Modal } from "react-bootstrap";
import FileUploadModal from "../Order/fileUpload";
import PackageDetails  from "../common/packageDetails"
import RescheduleToSameDay from "../common/rescheduleSameDay";
import { timeout } from "rxjs/operators";
import AddMerData from "../collectMerData/AddMerData";

class OrderCollection extends Component{


  constructor(props){
    super(props);
    console.log(this.props)
    this.myRef = React.createRef()
    this.state = {
        userdata : USER.user,
        orderStatus : null,
        orderDetails : null,
        cameraToggle: false,
        takingSampleForTestId : null,
        messageSnack: "",
        showSnack: false,
        testDetails: [],
        membersDetails : this.props.location.state ? this.props.location.state.membersData : localStorage.getItem('upsellMemberDetailsConfirm') ? JSON.parse(localStorage.getItem('upsellMemberDetailsConfirm')) : [],
        upsellMemberDetailsConfirm : localStorage.getItem('upsellMemberDetailsConfirm') ? false : true,
        showSampleCollected : true,
        modalShow : false,
        fileUploadModalShow: false,
        selectedSample : null,
        updateShow: false,
        showReschedulePopUp: false, 
        latitude : "0.0",
        longitude: "0.0",
        reassignLab: false,
        labId: null,
        labCentersAvailable: [],
        showPackageInfo: false,
        loadPackageDetails: false,
        allOrders: [],
        bulkSelectedSampleCollectedModal: false,
        bulkSelectedSampleCollectedUpdate: [],
        bulkUpdateLabCenter: [],
        bulkUpdateLabCenterModal: false,
        isMerFormDataRequired: false,
        isABHI: false,
        merFormDataCollected: false,
        showMerForm: false,
        latlongEventTriggerFunction : ev => {
            const that = this;
            console.log("lat long received event triggered",ev.detail);
        
            if (ev.detail !== null && ev.detail !== undefined) {
                const latlong = ev.detail.split(",");
                console.log("lat long split in an arr ",latlong);
                if(latlong !== null && latlong !== undefined) {
                    this.state.latitude = latlong[0]
                    this.state.longitude = latlong[1]
                    that.markOrderSampleCollected()
                } else {
                    that.showSnackbarFun("Location not received1, cannot continue", 2500)
                }   
            } else {
                that.showSnackbarFun("Location not received, cannot continue", 2500)
            }
            ev.stopImmediatePropagation();
        }
    }

  }

addEventListeners() {
    if (typeof android !== "undefined" && android !== null) {
        window.addEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
        console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
    }
}

showPackageInfoModal(){
    console.log('coming here')
    this.setState({
        showPackageInfo: !this.state.showPackageInfo
    })
}

cleanupListener() {
    if (typeof android !== "undefined" && android !== null) {
        window.removeEventListener('setLatLongFromApp', this.state.latlongEventTriggerFunction);
        console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
    }
}

componentDidMount(){
    this.addEventListeners();
    this.getOrderDetails();
    setTimeout(() => {

        if (this.state.orderDetails?.pendingOrders[0].aadharMandatory) {
            this.showAlert("Please update aadhar and patient details to move forward",2500);
        }
    },1000);
  }

componentDidUpdate (prevProps, prevState) {

    if (prevState.selectedSample != this.state.selectedSample && this.state.updateShow === false && 
        prevState.modalShow === this.state.modalShow && prevState.fileUploadModalShow === this.state.fileUploadModalShow ) {
        console.log("Update the page!!");
        this.addEventListeners();
        this.getOrderDetails();
    }
        
} 

componentWillUnmount() {
    this.cleanupListener();
}

showSnackbarFun(message, timeout){
    this.setState({
        messageSnacks: message,
        showSnackbar: true
    }, () => {
        this.toastComponent();
    })
    setTimeout(() => {
        this.setState({
            messageSnacks: "",
            showSnackbar: false,
        })
    }, timeout)
}


  showdisabledButton(){
    this.setState({
        showSampleCollected  : true
    })

    let testDetailsTemp =  this.state.testDetails;
    let membersDetailsTemp =  this.state.membersDetails;
    let testDetailsTempImageUploaded = true;
    let membersDetailsTempImageUploaded = true;

    testDetailsTemp.map(elem => {
        if(!elem.imageUploaded) {
            testDetailsTempImageUploaded = false;
        }
        if(elem.barcode == null){
            testDetailsTempImageUploaded = false;
        }
     })
     membersDetailsTemp.map(elem => {
            if(!elem.imageUploaded) {
                membersDetailsTempImageUploaded = false;
            }
            if(elem.barcode == null){
                testDetailsTempImageUploaded = false;
            }
         })

    if(testDetailsTempImageUploaded && membersDetailsTempImageUploaded && (this.state.isMerFormDataRequired ? this.state.merFormDataCollected : true)){
        this.setState({
            showSampleCollected  : false
        })
    }   
}

showAlert(message, timeout) {
    this.setState({
        messageSnack: message,
        showSnack: true
    });
    setTimeout(() => {
        this.setState({
            messageSnack: "",
            showSnack: false,
        })
    }, timeout);
}

callbackForCollection = (result) => {

    console.log(result);
    this.showAlert(result.message, 2500);
    this.addEventListeners();
    this.getOrderDetails();

}

// callBackFromReschdeule = (result) => {
//     console.log(result);
//     this.showAlert(result.message, 2500);
//     this.addEventListeners();
//     this.getOrderDetails();

// }

onEditCustomer(elem) {
    this.setState({updateShow:true, selectedSample:elem});
}

navigateToReschedule(id, time, reqId, city, DID, providerOrderId, name) {
    console.log(id, time);
    localStorage.setItem("AppointmentDate", JSON.stringify(time));
    localStorage.setItem("AppointmentId", JSON.stringify(reqId));
    localStorage.setItem("City", JSON.stringify(city));
    localStorage.setItem("DID", JSON.stringify(DID));
    localStorage.setItem("providerOrderId", JSON.stringify(providerOrderId));
    localStorage.setItem("name", JSON.stringify(name));
    let routerLink = '/sample/collected/Reschedule/'+id;
    this.props.history.push(routerLink);
}

// showReschedulePopUp (elem) {
//     this.setState({showReschedulePopUp: true, selectedSample:elem})
// }

getOrderDetails(){
    const that = this;
    let currOrderId = parseInt(this.props.match.params.orderId)
    let url = URL.dev_url;
     let route = url + 'getorders'
     let obj = {
        phleboId: this.state.userdata.phleboId,
     }
    that.getLabCenters()

    _axios.post(route,obj)
    .then(function (response) {
        let filteredOrder = {...response.data}; 
        filteredOrder.pendingOrders = filteredOrder.pendingOrders.filter(data => data.orderId == currOrderId)
        localStorage.setItem("order_details",JSON.stringify(response.data));
        localStorage.setItem('customer_phoneNumber',response.data.pendingOrders[0].patientDetails[0].phoneNumber)
        that.setState({
            loadPackageDetails: true,
            orderDetails : filteredOrder,
            allOrders: response.data.pendingOrders,
            testDetails :  filteredOrder ? filteredOrder.pendingOrders[0].tests : null,
            totalSamples : filteredOrder ? filteredOrder.pendingOrders[0].tests.length : 0 ,
            isMerFormDataRequired: filteredOrder && (ABHIErId.includes(filteredOrder.pendingOrders[0]?.patientDetails?.[0]?.entityRelationId) || merCompulsoryPackage.includes(filteredOrder.pendingOrders[0]?.tests?.[0]?.testId)) ? true : false,
            isABHI: filteredOrder && ABHIErId.includes(filteredOrder.pendingOrders[0]?.patientDetails?.[0]?.entityRelationId) ? true : false
        })
       
    }).catch(function (error) {
        console.log(error);
    })
    
}

getLabCenters() {
    const that = this;
    that.setState({
        loader : true
    })
    let route = URL.dev_url + 'getAllSPCByCity?city=' + USER.user.city
    _axios.get(route).then(function(res) {
        that.setState({
            loader : false,
            labCentersAvailable: res.data,
        })
    }).catch(function(err) {
        console.log(err);
        that.setState({
            loader : false,
            labAssigned: false
        })
    })
}

renderRedirect = (orderstatus) => {
      let x = this.props.match.path + '/' +orderstatus;
        this.props.history.push(x);
  }

  handleCameraToggleMembers(element,index){
    const that = this;

    let testDetailsTemp =  this.state.membersDetails;

    testDetailsTemp[index]["index"]=index;
    testDetailsTemp[index]["cameraToggle"]=true;
    testDetailsTemp[index]["b64"]=null;
    testDetailsTemp[index]["imageUploaded"] = null;
    testDetailsTemp[index]["barcode"] =  testDetailsTemp[index]["barcode"] ?  testDetailsTemp[index]["barcode"] : null;
       
    console.log("testDetailsTemp",testDetailsTemp);

     this.setState({
         membersDetails : testDetailsTemp,
     },()=>{
         that.checkCameraForMembers(index)
     })
 }

 callbackForMembersBarCode = (sampleValues) => {
    const that = this;
    console.log("child value::",sampleValues);

    let testDetailsTemp =  this.state.membersDetails;
    testDetailsTemp[sampleValues.index] = sampleValues;
    console.log("child value::",testDetailsTemp);


    this.setState({
        membersDetails : testDetailsTemp
    },()=>{
        localStorage.getItem('upsellMemberDetailsConfirm') ?  localStorage.setItem("upsellMemberDetailsConfirm",JSON.stringify(testDetailsTemp)) : null;
        this.getTotalSamples();
        this.showdisabledButton(); 
    })
  }

  
 callbackForMembers = (sampleValues) => {
    const that = this;
    console.log("child value::",sampleValues);

    let testDetailsTemp =  this.state.membersDetails;
    testDetailsTemp[sampleValues.index] = sampleValues;
    console.log("child value::",testDetailsTemp);
    this.setState({
        membersDetails : testDetailsTemp
    },()=>{
        localStorage.setItem("upsellMemberDetailsConfirm",JSON.stringify(testDetailsTemp));
        this.showdisabledButton();    
    })
 }


 checkCameraForMembers(index){
   let sampleCollection = this.state.membersDetails[index]
    if(sampleCollection) {
     if(!sampleCollection.imageUploaded){
         if(sampleCollection.cameraToggle)
             return(   
                 <WebcamCapture multipleImages={true} cameraFace="environment" dataParentToChild={sampleCollection} parentCallback={this.callbackForMembers}/> 
             ) 
         }
    }
}


  handleCameraToggle(test){
    const that = this;
    let cameraToggleTemp = !this.state.cameraToggleTemp;

    let testDetailsTemp =  this.state.testDetails;
    let takingSampleForTestId = test.testId;


    testDetailsTemp.map(elem => {
       if(elem.testId == test.testId) {
        elem["cameraToggle"]=true;
        elem["b64"]=null;
        elem["imageUploaded"] = false;
        elem["barcode"] =  elem["barcode"] ?  elem["barcode"] : null;
       }
    })
    console.log("testDetailsTemp",testDetailsTemp);


     this.setState({
         testDetails : testDetailsTemp,
         takingSampleForTestId: test.testId
     },()=>{
         that.checkCamera()
     })
 }

 callback = async(sampleValues) => {
    // do something with value in parent component, like save to state
    const that = this;
    console.log("child value::",sampleValues);
    let testDetailsTemp =  this.state.testDetails;

    testDetailsTemp.map(elem => {
       if(elem.testId == this.state.takingSampleForTestId) {
        elem = sampleValues;
       }
    })
    
    console.log("child value::",testDetailsTemp);

    this.setState({
        testDetails : testDetailsTemp
    },()=>{
        this.showdisabledButton()
    })
}

checkCamera(){
       if(this.state.testDetails &&  this.state.takingSampleForTestId) {

        let testDetailsTemp =  this.state.testDetails;
        let sampleCollection = null;
        testDetailsTemp.map(elem => {
           if(elem.testId == this.state.takingSampleForTestId) {
            sampleCollection = elem;
           }
        })
       
        if(!sampleCollection.imageUploaded){
            if(sampleCollection.cameraToggle)
                return(   
                    <WebcamCapture  multipleImages={true} cameraFace="environment" dataParentToChild={sampleCollection} parentCallback={this.callback}/> 
                ) 
            }
       }
}
redirectToUpsell(){
    localStorage.setItem("orderTestDetails",JSON.stringify(this.state.testDetails))
    let x = '/upsell/order/'+parseInt(this.props.match.params.orderId);
    this.props.history.push(x);
}
handleLabCenterChange(event) {
    console.log('hi')
    event.preventDefault();
    this.setState({labId: event.target.value});
}
updateLabCenter(val) {

    let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
    let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 4)
    let bulkUpdateLab = []
    relatedOrders.forEach(data => bulkUpdateLab.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
    if(bulkUpdateLab.length > 1){
        this.setState({
            bulkUpdateLabCenter: bulkUpdateLab,
            bulkUpdateLabCenterModal: true
        })
        return
    }

    const that = this;
    if(!this.state.labId) {
        this.showSnackbarFun("Please select lab center", 3000);
        return
    }
    let route = URL.dev_url + 'updateSPCForOrderId'
    _axios.post(route, {
        "orderId": this.state.orderDetails.pendingOrders[0].orderId,
        "spcId" : this.state.labId || val
    }).then(function(res) {
        window.location.reload();
        that.setState({
            labAssigned: true
        })
    }).catch(function(err) {
        console.log(err)
    })
}

redirectToCollectVitals(){
    localStorage.setItem("orderTestDetails",JSON.stringify(this.state.testDetails))
    let x = '/collect/vitals/'+parseInt(this.state.orderDetails.pendingOrders[0].prOrderId);
    this.props.history.push(x);
}

async uploadImageToS3(name,url){
        var url = url+'';
        var arr = url.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        console.log(u8arr);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        var p =  new File([u8arr], name, {type:mime});// send this file 


            var data = new FormData();
            data.append('FileName', name?.split('.')[0]);
            data.append('File', p);
            data.append('FileExtension', "jpeg");

            var config = {
              method: 'post',
              url: 'https://oms.medibuddy.in/oms/uploadFile',
              headers: { 
                'Content-Type': 'multipart/form-data', 
              },
              data : data
            };


           const response = await  _axios(config);
           console.log("guid should beb ..",response)
           let guid = Object.keys(response.data.file)[0]
            return guid;     
}
async redirectOtpCustomer(){
    // Phlebo Reached Patients home
    if (this.state.orderDetails.pendingOrders[0].aadharMandatory) {
        console.log(this.state.orderDetails);
        setTimeout(() => {
            this.myRef.current.scrollIntoView({ behavior: 'smooth' })
          }, 500)
    
    } else {

        if (typeof android !== "undefined" && android !== null) {
            console.log("Checking location in android");
            android.startLocationTracking();
        } else {
            
            if (!(this.props.isGeolocationAvailable && this.props.isGeolocationEnabled)) {
    
                this.showSnackbarFun("Geolocation not available/enabled, Please give permissions", 4500);
    
            } else if (this.props.coords != undefined && this.props.coords != null
                && this.props.coords != "") {
    
                this.state.longitude = this.props.coords.longitude
                this.state.latitude = this.props.coords.latitude
            }
    
            //marking order sample collected from react web app even if we don't have location coords
            this.markOrderSampleCollected();
        }
        
    }
       
}

async markOrderSampleCollected() {

    const that = this;

    // let memberOrderIds = JSON.parse(localStorage.getItem('upsellOrderIds'));
    let SampleGuids = [];
    let barCodesTestDetails = [];
    console.log("testDetails",this.state.testDetails)
    console.log("membersDetails",this.state.membersDetails)

    for (let i = 0; i < this.state.testDetails.length; i++) {
        if(this.state.testDetails[i].imageUploaded){

            for(let k = 0; k < this.state.testDetails[i].b64.length; k++){
            
                await watermark([this.state.testDetails[i].b64[k]])
                .image(text.lowerLeft(`Request # ${this.state.orderDetails.pendingOrders[0].appointmentId} AT: ${parseFloat(this.state.latitude).toFixed(4)}, ${parseFloat(this.state.longitude).toFixed(4)}`, '48px', '#fff', 0.9))
                .render()
                .image(text.upperLeft(`Time: ${new Date()}`, '48px', '#fff', 0.9))
                .then(async img => {
                let name = this.state.testDetails[i].testId + '_' + this.state.testDetails[i].barcode + k + '.jpeg';
                let guid = await this.uploadImageToS3(name,img.currentSrc);
                SampleGuids.push(guid)
                }
                );
             }
             this.state.testDetails[i]["SampleGuid"] = SampleGuids;
            //  let name = this.state.testDetails[i].testId + '_' + this.state.testDetails[i].testName + '.jpeg'
            //  let guid = await this.uploadImageToS3(name,this.state.testDetails[i].b64);
            //  this.state.testDetails[i]["SampleGuid"] = guid;
            //  SampleGuids.push(guid[0])
        }
        barCodesTestDetails.push(this.state.testDetails[i].barcode);
    }

    console.log("testDetails22",this.state.testDetails)

    let memberDetails = this.state.membersDetails;

    for (let i = 0; i < this.state.membersDetails.length; i++) {
        let memberSampleGuids = [];
        let barCodesMemberDetails = [];
        
        if(this.state.membersDetails[i].imageUploaded){

            for(let k = 0; k < this.state.membersDetails[i].b64.length; k++){

                await watermark([this.state.membersDetails[i].b64[k]])
                .image(text.lowerLeft(`Request # ${this.state.orderDetails.pendingOrders[0].appointmentId} AT: ${parseFloat(this.state.latitude).toFixed(4)}, ${parseFloat(this.state.longitude).toFixed(4)}`, '48px', '#fff', 0.9))
                .render()
                .image(text.upperLeft(`Time: ${new Date()}`, '48px', '#fff', 0.9))
                .then(async img => {
                    let name = this.state.membersDetails[i].testId + '_' + this.state.membersDetails[i].labtest + k + '.jpeg';
                    let guid = await this.uploadImageToS3(name,img.currentSrc);
                    memberSampleGuids.push(guid)
                }
                );
             }
             this.state.membersDetails[i]["SampleGuid"] = memberSampleGuids;


            //  let name = this.state.membersDetails[i].orderId + '_' + this.state.membersDetails[i].labtest + '.jpeg'
            //  let guid = await this.uploadImageToS3(name,this.state.membersDetails[i].b64);
            //  this.state.membersDetails[i]["SampleGuid"] = guid;
        }
        barCodesMemberDetails.push(memberDetails[i].barcode);
        memberDetails[i]['customerBarcodeArr'] = barCodesMemberDetails;
        memberDetails[i] = this.state.membersDetails[i];
        // memberDetails[i]['b64'] = null;

    }
    this.setState({
        memberDetails : memberDetails,
        SampleGuids : SampleGuids,
        barCodesTestDetails: barCodesTestDetails,
    })

    let bulkSelectedSampleCollectedUpdate = []
    let dependantId = this.state.orderDetails.pendingOrders[0].dependantId
    let relatedOrders = this.state.allOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 4)
    bulkSelectedSampleCollectedUpdate = []
    relatedOrders.forEach(data => bulkSelectedSampleCollectedUpdate.push({isSelected: true, appointmentId: data.appointmentId, labtestName: data.tests[0].testName, id: data.orderId}))
    if(bulkSelectedSampleCollectedUpdate.length == 1){
        let url = URL.dev_url;
        let route = url + 'updateorders';
        let obj = {
            access_token : "trialTest" || USER.access_token,
            currentStatusId : 4,
            requestNextStatusId : 5,
            phleboId: this.state.userdata.phleboId,
            orderId: parseInt(this.props.match.params.orderId),
            membersDetails : memberDetails,
            SampleGuids : SampleGuids,
            customerBarcodeArr: barCodesTestDetails,
            lat: parseFloat(this.state.latitude).toFixed(4).toString(),
            long: parseFloat(this.state.longitude).toFixed(4).toString(),
        }
    
            console.log("object",obj)
            _axios.post(route,obj)
            .then(function (response) {
                console.log("response",response.data);
                if(response.data.success){
                    // alert(response.data.message);
                    //  localStorage.removeItem('orderTestDetails');
                    localStorage.removeItem('upsellMemberDetailsConfirm');
                    localStorage.removeItem('upsellOrderIds');
                    that.setState({
                        bulkSelectedUpsellPitchModal : true,
                    })
                    // let x = '/otp/customer/'+obj.orderId;
                    // that.props.history.push(x);
                }
            }).catch(function (error) {
                console.log(error);
            })
    } else {
        this.setState({bulkSelectedSampleCollectedUpdate : bulkSelectedSampleCollectedUpdate})
        this.setState({bulkSelectedSampleCollectedModal : true})
    }

}

routeToCancelPage() {
    let x = '/cancel/' + this.props.match.params.orderId;
    this.props.history.push(x);
}

getTotalSamples(){
    let samplesCollected = 0;
    let testDetailsTemp =  this.state.testDetails;
    let membersDetailsTemp =  this.state.membersDetails;

    let totalSamples = 0;
    let testTotalSamples = 0;
    let memberTotalSamples = 0;

    if(testDetailsTemp){
        testDetailsTemp.map(elem => {
            console.log("elem",elem)
            if(elem.imageUploaded && elem.barcode !=null) {
             samplesCollected ++;
            }
         })
     testTotalSamples = testDetailsTemp.length;
    
    }
    if(membersDetailsTemp){
        membersDetailsTemp.map(elem => {
            console.log("elem",elem)
            if(elem.imageUploaded && elem.barcode !=null) {
             samplesCollected ++;
            }
         })
     memberTotalSamples =  membersDetailsTemp.length;
    }

    totalSamples = testTotalSamples + memberTotalSamples;
    if((totalSamples != 0) && (totalSamples == samplesCollected)){
        return (
                    <div>
                        <div className="text-align-center uppercase bold">
                            All Done  
                            <span className="green-color p-l-20">
                                <i className="fa fa-check" aria-hidden="true"></i>  
                            </span>
                            </div>   
                            <div className="text-align-center font-size-md bold red-color  p-t-10 p-b-10">
                                Total Samples collected {samplesCollected}
                            </div>
                    </div>
        )
       
    }else{
        return (
            <div className="text-align-center font-size-md bold red-color  p-t-10 p-b-10">
                Total Samples collected {samplesCollected}
             </div>
        )
        }  
    
}

async updateSampleCollectedOrderBulk(){
    try {
        this.setState({bulkSelectedSampleCollectedModal : false})
        for(let order of this.state.bulkSelectedSampleCollectedUpdate){
            if(!order.isSelected) continue
            let url = URL.dev_url;
            let route = url + 'updateorders';
            let obj = {
                access_token : "trialTest" || USER.access_token,
                currentStatusId : 4,
                requestNextStatusId : 5,
                phleboId: this.state.userdata.phleboId,
                orderId: order.id,
                membersDetails : this.state.memberDetails,
                SampleGuids : this.state.SampleGuids,
                customerBarcodeArr: this.state.barCodesTestDetails,
                lat: parseFloat(this.state.latitude).toFixed(4).toString(),
                long: parseFloat(this.state.longitude).toFixed(4).toString(),
            }
        
                let response = await _axios.post(route,obj)
                if(!response.data.success){
                    throw new Error('Something went wrong!!!')
                }
        }
        localStorage.removeItem('upsellMemberDetailsConfirm');
        localStorage.removeItem('upsellOrderIds');
        this.setState({
            bulkSelectedUpsellPitchModal : true,
            bulkSelectedSampleCollectedModal : false
        })
    } catch (error) {
        this.showSnackbarFun("Something went wrong!!!", 1500);
        this.setState({bulkSelectedSampleCollectedModal : false})
    }
    
    
}

toastComponent() {
    return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
}

onChangeLabCenter(id, e){
    let stateData = this.state.bulkUpdateLabCenter
    for(let data of stateData){
        if(data.id == id) data.isSelected = !data.isSelected
    }
    this.setState({
        bulkUpdateLabCenter: stateData
    })
}

async changeLabCenter(){
    try {
        if(!this.state.labId) {
            this.showSnackbarFun("Please select lab center", 3000);
            alert("Please select lab center")
            return
        }
        let promise = []
        for(let data of this.state.bulkUpdateLabCenter){
            if(!data.isSelected) continue
            let route = URL.dev_url + 'updateSPCForOrderId'
            promise.push(_axios.post(route, {
                "orderId": data.id,
                "spcId" : this.state.labId || val
            }))
        }
        await Promise.all(promise)
        window.location.reload();
        this.setState({
            labAssigned: true
        })
    } catch (error) {
        console.log(error)
    }
}

TriggerLinkValidation(){
    
    if(this.state.testDetails && this.state.testDetails.length > 0 &&
      this.state.orderDetails?.pendingOrders[0]?.patientDetails[0]?.corporateName?.toLowerCase().includes("tata aia")){
        let tests = this.state.testDetails[0].testName.split("PPMC Details : ")[1].split(",");
        let merArray = ["ME","MER","MER with RUA", "Medical Examination Report"]
        let ismer = false;
        if(tests){
            for( let elem of tests ){
                if(merArray.includes(elem)){
                    ismer = true;
                    break;
                }
            }
        }
       
        return ismer;
    }
    
}
markBulkSampleCollectedUpdate(id, e){
    const relatedOrders = this.state.bulkSelectedSampleCollectedUpdate
    for(let data of relatedOrders){
        if(data.id == id){
            data.isSelected = !data.isSelected
            break
        }
    }
    this.setState({bulkSelectedSampleCollectedUpdate: relatedOrders})
}

showMemberDetails(){
    return( <div>
        {
                this.state.membersDetails ? this.state.membersDetails.map((elem,index) => (    
                            <Container key={index} >
                                  <hr className="style-straight"></hr> 
                                
                                <Row className="p-l-10 p-r-10 p-b-10">
                                    <Col xs={12} md={12}>
                                        <div  className="font-size-sm uppercase">
                                            Name
                                        </div>
                                        <div className="font-size-smd bold">
                                            {elem.name}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="p-l-10 p-r-10 p-b-10">
                                    <Col xs={4} md={4}>
                                            <div  className="font-size-sm uppercase">
                                                Relationship
                                            </div>
                                            <div className="font-size-smd bold">
                                            {elem.relationship}
                                            </div>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <div  className="font-size-sm">
                                           Age
                                        </div>
                                        <div className="font-size-smd bold">
                                            {elem.age}
                                        </div>
                                    </Col>
                                    <Col xs={4} md={4}>
                                        <div  className="font-size-sm">
                                           Gender
                                        </div>
                                        <div className="font-size-smd bold">
                                            {elem.gender}
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={12}>
                                            <div className="p-10">   
                                                <div className="font-size-sm">
                                                <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                                    TEST
                                                </div>
                                                <div className="font-size-smd bold">
                                                    <ol>
                                                        <li>
                                                            <div>

                                                            <div className="display-flex justify-content-space-between p-b-10">
                                                                <div>
                                                                    {elem.labtest}
                                                                </div>   
                                                                <div>
                                                                    {
                                                                        elem.imageUploaded ?   
                                                                        <span className="green-color">
                                                                            <i className="fa fa-check" aria-hidden="true"></i>  
                                                                        </span> :  ''
                                                                    }
                                                                        <span  className="p-l-20" onClick={()=> this.handleCameraToggleMembers(elem,index)}>
                                                                            <i className="fa fa-camera width-10" aria-hidden="true"></i>  
                                                                        </span>
                                                                    
                                                                </div>
                                                               
                                                            </div>
                                                            <div className="text-align-center">
                                                                    <button type="button" className="btn btn-outline-info" onClick={()=>this.setState({modalShow:true, selectedSample:elem})}>
                                                                        <span className="font-size-smd" >
                                                                            <i className="fa fa-search p-r-5" aria-hidden="true"></i>
                                                                            Scan Bar Code
                                                                        </span>
                                                                    </button>   
                                                                
                                                                {/* <i className="fa fa-barcode p-r-5" aria-hidden="true" onClick={()=>this.setState({modalShow:true, selectedSample:elem})}></i> */}
                                                                </div>
                                                                <div className="text-align-center p-t-5">  
                                                                    {elem.barcode ?
                                                                    <div>
                                                                        <i className="fa fa-barcode font-size-lg" aria-hidden="true"></i>
                                                                        <div className="font-size-smd bold">
                                                                            {elem.barcode}
                                                                        </div>
                                                                    </div>
                                                                    : ''}
                                                                </div>

                                                            </div>
                                                       
                                                        </li>
                                                     
                                                    </ol> 
                                                </div>
                                            </div>
                                    </Col>
                                </Row>
                                <Row>
                                <div className="width-100">
                                     {this.checkCameraForMembers(index)}
                                </div>
                                </Row>
                                <Row>
                                <div  className="width-100">
                                    <div  className="display-flex flex-wrap justify-content-center p-t-10">
                                        
                                                <div>
                                                    {
                                                        elem.imageUploaded ? 
                                                                <div className="text-align-center">
                                                                    <div className="font-size-smd bold p-b-5">
                                                                        Sample : {elem.labtest}
                                                                    </div>
                                                                    {/* <img className="p-1"  src={elem.b64} alt='samples' /> */}
                                                                    <div> 
                                                                        {
                                                                            elem.b64 ? elem.b64.map( (elem,index) => (
                                                                            <div key={index}  className="width-100 text-align-center p-b-10">
                                                                                <img className="width-100 text-align-center p-b-10" src={elem}></img>
                                                                            </div> 
                                                                            )): ''
                                                                        } 
                                                                    </div>
                                                                    {/* <hr className="style-straight"></hr> */}
                                                                </div>
                                                        
                                                    : ''
                                                    }




                                                </div>
                                               
                                        
                                    </div>
                                </div>
                                </Row>
                              
                            </Container>
                    )): ''
        }
       </div>
       
)
}

    redirectToCollectMerData(){
        this.setState({
            showMerForm: true
        })
    }

    handleGoBackFromMer = (isMerFormCollected) => {
        this.setState({
            showMerForm: false,
            merFormDataCollected: isMerFormCollected
        })
        this.showdisabledButton();
    }

  render(){
      console.log("this.state...",this.state)
    return(
        this.state.showMerForm ? 
        <AddMerData 
            filteredOrders = { this.state.orderDetails}
            isABHI = { this.state.isABHI }
            handleGoBackFromMer = {(isMerFormCollected) => this.handleGoBackFromMer(isMerFormCollected)}
        /> :
        <div ref={this.myRef}>
            {/* <ToastComponent dataParentToChild={this.state.sendToast}></ToastComponent> */}
            <Modal
                    size="md"
                    style={{height: "100vh !important"}}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkUpdateLabCenterModal}
                    onHide={() => {this.setState({bulkUpdateLabCenterModal: false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkUpdateLabCenter.map(data => (

                                data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.onChangeLabCenter(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.changeLabCenter()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
            <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedSampleCollectedModal}
                    onHide={() => {this.setState({bulkSelectedSampleCollectedModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.bulkSelectedSampleCollectedUpdate.map(data => (
                                data.id != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkSampleCollectedUpdate(data.id, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.labtestName} (# ${data.appointmentId})`}</label>
                                </div>
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.updateSampleCollectedOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.bulkSelectedUpsellPitchModal}
                    onHide={() => {this.setState({bulkSelectedUpsellPitchModal : false})}}
                    >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Did you convince customer to take upsell tests?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="danger" onClick={() => {this.setState({bulkSelectedUpsellPitchModal : false});this.props.history.push('/otp/customer/'+ this.props.match.params.orderId);}}>No</Button>
                        <Button variant="primary" onClick={() => {this.setState({bulkSelectedUpsellPitchModal : false});this.props.history.push('/otp/customer/'+ this.props.match.params.orderId);}}>Yes</Button>
                    </Modal.Footer>
                </Modal>
            <div className="order-details-dashboard" >
                <div>
                    {
                        this.state.orderDetails ? <HeaderSample titleCall={false}  
                        // props = {this.props}
                        orderHeader={this.state.orderDetails.pendingOrders[0]} 
                        noCall={this.state.orderDetails.pendingOrders[0].noCall}
                        onEditCustomer = {(elem) => this.onEditCustomer(elem)}
                        onRescheduleRoute = {(id, time , reqId, city, did, orderId, name) => this.navigateToReschedule(id, time, reqId, city, did, orderId, name)}
                        ></HeaderSample> : ''
                    }
                      
                </div>
                <div>
                    <Container>
                    <Row>
                            <Col xs={12} md={12}>
                                <div className="p-10">   
                                    <div className="font-size-sm">
                                        <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                        Customer Address
                                    </div>
                                    <div className="font-size-smd bold p-l-15">
                                        {
                                            this.state.orderDetails && this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1 ? <span> {this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine1}, </span> : '' 
                                        }
                                        {   
                                             this.state.orderDetails && this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2 ? <span> {this.state.orderDetails.pendingOrders[0].patientDetails[0].addressLine2}, </span> : ''
                                        }
                                        { this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].landmark : ''}  -  { this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].pincode : ''}
                                    </div>
                                </div>
                                <div className="p-10">   
                                    <div className="font-size-sm">
                                        <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                        <span>Lab Address</span>
                                        <button onClick={() => {
                                            this.setState({
                                                reassignLab: !this.state.reassignLab
                                            })
                                        }} className="btn btn-default btn-sm patientEdit m-b-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                        </svg> 
                                        </button>
                                    </div>
                                    <div className="font-size-smd bold p-l-15">
                                    {   
                                        this.state.orderDetails && this.state.orderDetails.pendingOrders[0].labDetails && this.state.orderDetails.pendingOrders[0].labDetails.AssignedLab && !this.state.reassignLab ? 
                                        <>
                                        <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLab}, </span>
                                        <span> {this.state.orderDetails.pendingOrders[0].labDetails.AssignedLabAddress 
                                            + ", "
                                            + this.state.orderDetails.pendingOrders[0].labDetails.AssignedLabPincode} </span>
                                        </> : 
                                        <Form onSubmit={(e)=>this.updateLabCenter(this.state.labId)}>
                                            <Form.Group controlId="formGroupSelectLabCenter">
                                                <Form.Label>Select a Lab Center</Form.Label>
                                                <Form.Control as="select" onChange={(e)=>this.handleLabCenterChange(e)}>
                                                    <option value="">Select</option>
                                                    { 
                                                        this.state.labCentersAvailable.map((each, idx) => (
                                                            // {each.labId}
                                                            <option key={idx} value={each.labid}>{each.labName + ', ' + each.labaddressline1}</option>
                                                        ))
                                                    }
                                                </Form.Control>
                                            </Form.Group>
                                            <Button variant="primary" type="submit"  className="text-align-center w-100"> Save </Button>
                                        </Form>
                                    }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <div className="p-10">   
                                    <div className="font-size-sm">
                                    <i className="fa fa-flask width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                                        TESTS
                                        <button className="btn btn-default -m-t-10" onClick={() => this.showPackageInfoModal()}><svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="20px" height="20px">    <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"/></svg></button>
                                    </div>
                                    <div className="font-size-smd bold">
                                        <ol>
                                            {this.state.testDetails ? this.state.testDetails.map((elem,index) => {
                                                return <li key={index}> 
                                                <div>
                                                <div className="display-flex justify-content-space-between p-b-10">
                                                    <div className="break-words">
                                                        {elem.testName}
                                                     </div>   

                                                     <div>
                                                         {
                                                             elem.imageUploaded ?   
                                                             <span className="green-color">
                                                                 <i className="fa fa-check" aria-hidden="true"></i>  
                                                             </span> :  ''
                                                         }
                                                         
                                                     </div>
                                                </div>

                                                { elem.testDetails != null ? 
                                                <div className="display-flex justify-content-space-between p-b-10">
                                                    <div className="break-words">
                                                        { "Test Details : " + elem.testDetails}
                                                     </div>   
                                                </div>
                                                : ""
                                                }

                                                <div className="text-align-center">
                                                    <Row className="width-100 p-b-10">
                                                        
                                                        <button type="button" className=" btn btn-outline-info" onClick={()=> this.handleCameraToggle(elem)}>
                                                            <span className="font-size-smd" >
                                                                <i className="fa fa-camera width-10 p-r-20" aria-hidden="true"></i>
                                                                Take Sample Photo
                                                            </span>
                                                        </button>     
                                                        
                                                     </Row>
                                                     <Row className=" width-100 p-b-10">
                                                        <button type="button" className="btn btn-outline-info" onClick={()=>this.setState({modalShow:true, selectedSample:elem})}>
                                                            <span className="font-size-smd" >
                                                                <i className="fa fa-search p-r-5" aria-hidden="true"></i>
                                                                Scan Bar Code
                                                            </span>
                                                        </button> 

                                                     </Row>
                                                      
                                                 
                                                 {/* <i className="fa fa-barcode p-r-5" aria-hidden="true" onClick={()=>this.setState({modalShow:true, selectedSample:elem})}></i> */}
                                                </div>
                                                <div className="text-align-center p-t-5">  
                                                    {elem.barcode ?
                                                    <div>
                                                        <i className="fa fa-barcode font-size-lg" aria-hidden="true"></i>
                                                        <div className="font-size-smd bold">
                                                            {elem.barcode}
                                                        </div>
                                                    </div>
                                                    : ''}
                                                </div>

                                                </div>  
                                                </li> 
                                            }) : ''} 
                                        </ol> 
                                    </div>
                                </div>
                            </Col>
                        </Row>
                      </Container>
                     
                      <Container>    
                        <Row>
                                <div className="width-100">
                                    {this.checkCamera()}
                                </div>
                                <div  className="width-100">
                                    <div  className="display-flex flex-wrap justify-content-center p-t-10">
                                        {this.state.testDetails ? this.state.testDetails.map((elem,index) => {
                                        return(
                                                <div key={index}>
                                                    {
                                                        elem.imageUploaded ? 
                                                                <div className="text-align-center">
                                                                    <div className="font-size-smd bold p-b-5">
                                                                        Sample : {elem.testName}
                                                                    </div>
                                                                    {/* <img className="p-1"  src={elem.b64} alt='samples' /> */}
                                                                    <div> 
                                                                        {
                                                                            elem.b64 ? elem.b64.map( (elem,index) => (
                                                                            <div key={index}  className="width-100 text-align-center p-b-10">
                                                                                <img className="width-100 text-align-center p-b-10" src={elem}></img>
                                                                            </div> 
                                                                            )): ''
                                                                        } 
                                                                    </div>

                                                                    {
                                                                        index < (this.state.testDetails.length - 1) ?  <hr className="style-straight"></hr> : ''
                                                                    }
                                                                </div>
                                                        
                                                    : ''
                                                    }
                                                </div>
                                                )
                                                }) : ''
                                        } 
                                    </div>
                                </div>
                        </Row>
                    </Container>

                    <div className="p-10">
                            {this.showMemberDetails()}
                     </div>
                    {
                        this.state.orderDetails && this.state.orderDetails.pendingOrders[0].tests[0].testType  == 'PPMC' && 
                        
                        <div className="display-flex justify-content-space-around">
                            {
                                this.TriggerLinkValidation() && 
                                <div>
                                    <button type="button" className="btn btn-outline-info" onClick={()=>this.setState({fileUploadModalShow:true})}>
                                        <span className="font-size-smd" >
                                            Trigger Link
                                        </span>
                                    </button>   
                                </div>
                            }
                           
                            <div>
                                <button type="button" className="btn btn-outline-info" onClick={()=> this.redirectToCollectVitals()}>
                                    <span className="font-size-smd" >
                                        Collect Vitals
                                    </span>
                                </button>  
                            </div>
                        </div>
                        
                    }
                    {(this.state.orderDetails && this.state.orderDetails.pendingOrders[0].tests[0].testType  != 'PPMC' || this.state.isMerFormDataRequired) && 
                        <div className="display-flex justify-content-space-around mt-2">          
                            <div>
                                <button type="button" className="btn btn-outline-info" onClick={()=> this.redirectToCollectMerData()}>
                                    <span className="font-size-smd" >
                                        Collect MER Data
                                    </span>
                                </button>  
                            </div>
                        </div>
                    }
                     
                     <Container>
                        <Row>
                                <Col xs={12} md={12}>
                                    {this.getTotalSamples()}
                                </Col>
                            </Row>
                     </Container>
                </div>
            </div>


            <div>
                  <Container>
                  
                      
                          <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                          <Row>
                            <Col>
                             <div className="display-flex justify-content-space-between">
                                 
                            
                                <Button variant="primary" size="md" block className="border-curve-10" onClick={()=> this.routeToCancelPage()}>   
                                    Reject
                                </Button>
                                 
                            </div>
                            </Col>

                            <Col>
                            <div className="display-flex justify-content-space-between ">
                            {
                                  this.state.upsellMemberDetailsConfirm ? 
                                    <>
                                        <div>
                                        <Button variant="primary" size="md" block className="border-curve-10" disabled={this.state.showSampleCollected} onClick={()=> this.redirectOtpCustomer()}>
                                            Sample Collected
                                        </Button>
                                        </div>
                                    </>                                        
                                  :
                                  <div>
                                    <Button variant="primary" size="md" block className="border-curve-10" disabled={this.state.showSampleCollected} onClick={()=> this.redirectOtpCustomer()}>
                                        Sample Collected
                                    </Button>
                                    
                                  </div>

                              }
                            </div>          
                            </Col>
                            </Row>
                          </div>
                          
                     
                  </Container>
                  
                </div>
                {this.state.fileUploadModalShow && <FileUploadModal
                            vendor={this.state.orderDetails?.pendingOrders[0]?.patientDetails[0]?.corporateName}
                            applicationid={this.state.orderDetails.pendingOrders[0].patientDetails[0].employeeId}
                            show={this.state.fileUploadModalShow}
                            onHide={() => this.setState({fileUploadModalShow:false})}
                        />}
                {this.state.modalShow && <BarCodeModal
                    show={this.state.modalShow}
                    dataparenttochild={this.state.selectedSample}
                    parentCallback={(result) => this.callbackForMembersBarCode(result)}
                    onHide={() => this.setState({modalShow:false})}
                />}
                {this.state.showSnack ? <div className="snackbar2 show">{this.state.messageSnack}</div> : ''}
                {this.state.updateShow && <UpdateCustomer
                    show={this.state.updateShow}
                    dataToHeaderSample = { (res) => {if (res) {this.setState({orderDetails: res})}}}
                    sendOrderDetails = {this.state.orderDetails}
                    dataparenttochild={this.state.selectedSample}
                    parentCallback={async (result) => await this.callbackForCollection(result)}
                    props = {this.props}
                    onHide={() => this.setState({updateShow:false})}
                />}
                {this.state.showReschedulePopUp && <RescheduleToSameDay
                    show={this.state.showReschedulePopUp}
                    dataToHeaderSample = { (res) => {if (res) {this.setState({orderDetails: res})}}}
                    sendOrderDetails = {this.state.orderDetails}
                    dataparenttochild={this.state.selectedSample}
                    parentCallback={async (result) => await this.callBackFromReschdeule(result)}
                    props = {this.props}
                    onHide={() => this.setState({showReschedulePopUp:false})}
                />}
            {this.state.loadPackageDetails && < PackageDetails showPackageInfo={this.state.showPackageInfo} showPackageInfoModal={() => this.showPackageInfoModal()} appointmentId={this.state.orderDetails.pendingOrders[0].appointmentId} packageName={this.state.orderDetails.pendingOrders[0].tests[0].testName} />}
        </div>
    )
    }
}
export default geolocated({
    positionOptions: {
        enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
})(OrderCollection);